// firebase/index
export const firebaseConfig = {
  apiKey: "AIzaSyDxybQn5ZXxYCeB6Dx87k038PN8BupKL1M",
  authDomain: "simposio-aaqct-inti.firebaseapp.com",
  projectId: "simposio-aaqct-inti",
  storageBucket: "simposio-aaqct-inti.appspot.com",
  messagingSenderId: "279179058568",
  appId: "1:279179058568:web:3ceae52ab56a5fce7aee3d",
  measurementId: "G-7YKS4LLDQP"
}

// firebase/storage
export const storageUrl = 'https://firebasestorage.googleapis.com/v0/b/simposio-aaqct-inti.appspot.com/o/'